import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LogoModule } from '../shared/logo/logo.module';
import { LangModule } from '../shared/lang/lang.module';
import { NavModule } from './nav/nav.module';
import { UserModule } from './user/user.module';
import { EnvelopeModule } from './envelope/envelope.module';

import { HeaderComponent } from './header.component';

const HEADER_MODULES = [LogoModule, LangModule, NavModule, UserModule, EnvelopeModule];

@NgModule({
  imports: [CommonModule, HEADER_MODULES],
  declarations: [HeaderComponent],
  exports: [HeaderComponent]
})
export class HeaderModule {}
